export const routes = {
  BALANCES: '/balances',
  HOME: '/',
  LOGIN: '/login',
  FORGOTPASSWORD: '/forgotpassword',
  CREATENEWPASSWORD: '/createnewpassword',
  RESERVATIONS: '/reservations',
  GROUP_BOOKINGS: '/group-bookings',
  INBOX: '/inbox',
  RESERVATION_DETAILS: '/reservations/:reservationId/details',
  ARTICLES: '/articles',
  CATEGORIES: '/categories',
  REPORTS: '/occupancy-reports',
  REVENUEREPORTS: '/revenue-reports',
  ROOMREVENUEREPORTS: '/room-revenue-reports',
  ADDONSREVENUEREPORTS: '/addons-revenue-reports',
  RESERVATIONSREPORTS: '/reservationsreports',
  ARTICLES_DETAILS: '/articles-details',
  ACCEPT_INVITE: '/accept-invite',
  MORE: '/more',
  USERS_MANAGEMENT: '/users',
  USERS_ARTICLES: '/articles-dashboard',
  ROLE_MANAGEMENT: '/roles',
  ROOMS: '/rooms',
  PROPERTIES: '/properties',
  RESERVATION: '/reservation',
  PACKAGES: '/packages',
  PACKAGES_MANAGEMENT: '/packages-management',
  GUEST_PORTAL_V2: '/guest-portal/:reservationId',
  GUEST_REGISTRATION_V2: '/guest-registration/:reservationId',
  FEEDBACK_V2: '/feedback/:reservationId',
};

export const endpoints = {
  BALANCES: 'v1/balances',
  DUE_BALANCES: 'v1/balances/due-payment',
  CREATE_PAYMENT_INTENT: 'v2/reservations/create-payment',
  CREATE_CUSTOMER_SESSION: 'v2/reservations/create-customer-session',
  GET_DEFAULT_PAYMENT_METHOD: 'v2/reservations/payment/guest-default-card',
  MEWS_RESERVATIONS: 'v2/reservations',
  RESERVATION: 'v2/reservations',
  TOKEN_AUTH: 'v1/auth/token',
  CATEGORIES: 'v1/categories',
  PROPERTIES: 'v1/properties',
  MESSAGING: 'v1/messaging',
  ROOMS: 'v1/rooms',
  USERS: 'v1/users',
  ARTICLES: 'v1/articles',
  ARTICLES_STATUS: 'v1/articles/status',
  USER_PERMISSIONS: 'v1/users/permissions',
  ROLES: 'v1/roles',
  PAYMENTS: 'v1/payments/reservation-payments',
  PAYMENT_METHODS: 'v1/payments/payment-methods',
  CREATE_REFUND: 'v1/payments/refund-charge',
  PAYOUT_INFORMATION: 'v1/reservations/payout-information',
  PACKAGES: 'v1/packages',
  PACKAGES_PRIORITIES: 'v1/packages/priority/update-priorities',
  GUESTS: 'v1/guests',
  GUEST_RESERVATIONS: 'v1/guest-reservations',
  LOCKS: 'v2/locks',
  RATING: 'v1/reservation-ratings',
  REPORTS: 'v1/reports',
  RESERVATION_PACKAGES: 'v1/packages/reservation-packages',
  PREVIOUS_RESERVATIONS: 'v1/guest-reservations/previous-reservations',
  CONFIG: 'v1/config',
  OPTIONS: 'v1/options',
  PERMISSIONS: 'v1/permissions',
  COMPONENTS: 'v1/components',
  SYNC_RESERVATION: 'v1/sync/mews/reservations',
  PROPERTY_RESERVATION_STEPS: 'v1/properties/:propertyId/registration-steps',
  RESERVATION_STEPS: 'v2/reservations/:reservationId/registration-steps',
  USER_DETAILS_STEP: 'v1/guests/registration-step/guest-details',
  ID_UPLOAD_STEP: 'v1/guests/registration-step/id-card',
  AGREEMENT_STEP: 'v1/guests/registration-step/agreement',
  CONFIRM_REGISTRATION_STEP: 'v1/guests/registration-step/confirm-registration',
  SYNC_CONVERSATIONS: 'v1/sync/conversations',
  MESSAGING_TEMPLATES: 'v1/options/messaging-templates',
  SEND_MESSAGING_TEMPLATE: 'v1/messaging-template/send-reservation-template',
  PROPERTY_MESSAGING_TEMPLATES: 'v1/properties',
  DYNAMIC_QUESTIONS: 'v1/properties/:propertyId/dynamic-questions',
  UPDATE_DYNAMIC_QUESTIONS: 'v1/properties/:propertyId/dynamic-questions/:questionId',
  DYNAMIC_ANSWERS: 'v1/properties/:propertyId/dynamic-answers/:reservationId',

  DYNAMIC_QUESTION_ANSWERS_BY_RESERVATION:
    'v1/properties/:propertyId/dynamic-questions/answers/:reservationId',
};
